<template>
    <cod-dialog
        :show.sync="showDialog"
        max-width="400px"
    >
        <div slot="content" class="order-reference">
            <v-alert
                type="info"
                text
            >
                {{ $t('order.reference_add') }}
            </v-alert>

            <v-text-field
                v-model="form.refOrder"
                v-mask="'NNNNNNNN-NNNNNNNN-#?#?#?#?#?#?#?#'"
                :error-messages="form.$errors.refOrder"
                :label="$t('receipt.ref_number')"
                @blur="form.validate('refOrder')"
                @input="delete form.$errors.refOrder"
            />

            <v-text-field
                v-model="form.refTime"
                v-mask="'##.##.####. ##:##:##'"
                placeholder="dd.mm.yyyy. hh:mm:ss"
                :error-messages="form.$errors.refTime"
                :label="$t('receipt.ref_time')"
                @blur="form.validate('refTime')"
                @input="delete form.$errors.refTime"
            />

            <div class="d-flex justify-center mt-3 mb-2">
                <v-btn
                    class="mr-3"
                    color="primary"
                    large
                    outlined
                    @click="clear"
                >
                    {{ $t('general.clear') }}
                </v-btn>
                <v-btn
                    color="primary"
                    large
                    @click="save"
                >
                    {{ $t('general.save') }}
                </v-btn>
            </div>
        </div>
    </cod-dialog>
</template>

<script>
import CodDialog from '@/components/CodDialog';
import { mapGetters } from 'vuex';
import * as rules from 'vuelidate/lib/validators'

export default {
    components: {
        CodDialog
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            showDialog: false,
            form: this.createForm()
        }
    },

    validations: {
        form: {
            refOrder: {
                required: rules.required,
                sdcNumber: rules.helpers.withParams(
                    { type: 'sdcNumber' },
                    function(value) {
                        if(!value) return true

                        const segments = value.split('-');
                        if(segments.length !== 3) return false;

                        return /^[0-9]+$/.test(segments[2])
                    }
                )
            },
            refTime: {
                requiredIf: rules.requiredIf(form => locale === 'sr'),
                date: rules.helpers.withParams(
                    { type: 'date' },
                    function(value) {
                        if(!value) return true

                        const date = moment(value, 'DD.MM.YYYY. HH:mm:ss', true);
                        return date.isValid() && date.isBefore(moment());
                    }
                )
            },
        }
    },

    watch: {
        show(val) {
            this.showDialog = val;

            if (val) {
                this.form = this.createForm()
            }
        },
        showDialog(val) {
            this.$emit('update:show', val);
        },
    },

    computed: {
        ...mapGetters(['curOrder']),
    },

    methods: {
        createForm() {
            let refOrder = null;
            let refTime = null;

            if(this.curOrder && this.curOrder.flag && this.curOrder.flag.startsWith('ref,')) {
                const reference = this.curOrder.flag.split(',');
                refOrder = reference[1];
                refTime = reference[2];
            }

            return new Form(this, 'form', { refOrder, refTime })
        },

        save() {
            if (!this.form.validate()) return;

            this.$emit('save', { refOrder: this.form.refOrder, refTime: this.form.refTime });
            this.showDialog = false;
        },

        clear() {
            this.$emit('save', { refOrder: null, refTime: null });
            this.showDialog = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.order-reference {
    padding: 16px;
}
</style>
